<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
        <a routerLink="/admin/support" class="btn btn-sm btn-outline-secondary mb-3">
            ← Back to Tickets
        </a>

        <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border spinner-border-sm"></div>
        </div>

        <div *ngIf="ticket" class="row g-3">
            <div class="card shadow-sm border-0 mb-3" *ngIf="ticket.sla as sla">
                <div class="card-body">
                    <h6 class="fw-bold">SLA</h6>

                    <div class="small mb-2"><strong>Stage:</strong> {{ sla.stage }}</div>
                    <div class="small mb-2"><strong>Due At:</strong> {{ sla.dueAt ? (sla.dueAt | date:'short') : 'N/A'
                        }}</div>
                    <div class="small mb-2"><strong>Status:</strong>
                        <span *ngIf="sla.isBreached" class="text-danger fw-semibold">Overdue</span>
                        <span *ngIf="!sla.isBreached && sla.isDueSoon" class="text-warning fw-semibold">Due Soon</span>
                        <span
                            *ngIf="!sla.isBreached && !sla.isDueSoon && ticket.status !== 'Resolved' && ticket.status !== 'Closed'"
                            class="text-success fw-semibold">On Track</span>
                        <span *ngIf="ticket.status === 'Resolved' || ticket.status === 'Closed'"
                            class="text-muted fw-semibold">Resolved</span>
                    </div>

                    <div class="small" *ngIf="sla.minutesRemaining !== null && sla.minutesRemaining !== undefined">
                        <strong>Minutes Remaining:</strong> {{ sla.minutesRemaining }}
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="card shadow-sm border-0">
                    <div class="card-body">
                        <h5 class="fw-bold mb-1">{{ ticket.subject }}</h5>
                        <div class="small text-muted mb-3">
                            {{ ticket.category }} • {{ ticket.status }} • {{ ticket.priority }}
                        </div>

                        <div class="mb-3">
                            <div *ngFor="let m of ticket.messages" class="mb-2">

                                <div class="p-2 rounded border" [ngClass]="{
                    'bg-primary text-white border-primary': m.senderType === 'User',
                    'bg-light': m.senderType !== 'User' && !m.isInternalNote,
                    'bg-warning-subtle border-warning': m.isInternalNote
                  }">

                                    <div class="small fw-bold">
                                        {{ m.senderType }} <span *ngIf="m.isInternalNote">(Internal Note)</span>
                                    </div>
                                    <div>{{ m.message }}</div>
                                    <div class="small opacity-75">
                                        {{ m.createdAt | date:'short' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card border-0 bg-light">
                            <div class="card-body">
                                <div class="mb-2">
                                    <label class="form-label">Reply / Note</label>
                                    <textarea [(ngModel)]="message" rows="4" class="form-control"
                                        placeholder="Write a reply or internal note..."></textarea>
                                </div>

                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" id="internalNote"
                                        [(ngModel)]="isInternalNote" />
                                    <label class="form-check-label" for="internalNote">
                                        Save as internal note
                                    </label>
                                </div>

                                <button class="btn btn-primary" type="button" [disabled]="sending"
                                    (click)="sendMessage()">
                                    {{ sending ? 'Sending...' : 'Send' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="card shadow-sm border-0 mb-3">
                    <div class="card-body">
                        <h6 class="fw-bold">Ticket Info</h6>
                        <div class="small mb-2"><strong>Status:</strong> {{ ticket.status }}</div>
                        <div class="small mb-2"><strong>Category:</strong> {{ ticket.category }}</div>
                        <div class="small mb-2"><strong>Priority:</strong> {{ ticket.priority }}</div>
                        <div class="small mb-2"><strong>Source:</strong> {{ ticket.source || 'N/A' }}</div>
                        <div class="small mb-2"><strong>User ID:</strong> {{ ticket.userId || 'N/A' }}</div>
                        <div class="small mb-2"><strong>Related Type:</strong> {{ ticket.relatedEntityType }}</div>
                        <div class="small mb-2"><strong>Related ID:</strong> {{ ticket.relatedEntityId || 'N/A' }}</div>
                        <div class="small mb-2"><strong>Created:</strong> {{ ticket.createdAt | date:'short' }}</div>
                        <div class="small"><strong>Updated:</strong> {{ ticket.lastUpdatedAt | date:'short' }}</div>
                    </div>
                </div>

                <div class="card shadow-sm border-primary mb-3" *ngIf="isReactivationTicket()">
                    <div class="card-body">
                        <h6 class="fw-bold text-primary">Account Reactivation</h6>
                        <p class="small text-muted">
                            The account owner verified this request through the email link. Review the ticket context and account history before approval.
                        </p>

                        <label class="form-label small">Approval reason / note</label>
                        <textarea
                            class="form-control mb-3"
                            rows="3"
                            maxlength="500"
                            [(ngModel)]="reactivationReason"
                            placeholder="Optional internal reason for approving reactivation"></textarea>

                        <button
                            class="btn btn-primary w-100"
                            type="button"
                            [disabled]="reactivatingAccount"
                            (click)="reactivateAccount()">
                            {{ reactivatingAccount ? 'Reactivating Account...' : 'Approve Account Reactivation' }}
                        </button>
                    </div>
                </div>

                <div class="card shadow-sm border-0 mb-3">
                    <div class="card-body">
                        <h6 class="fw-bold">Update Status</h6>

                        <div class="mb-3">
                            <select class="form-select" [(ngModel)]="selectedStatus">
                                <option *ngFor="let item of statuses" [value]="item">
                                    {{ item }}
                                </option>
                            </select>
                        </div>

                        <button class="btn btn-outline-primary w-100" type="button" [disabled]="savingStatus"
                            (click)="updateStatus()">
                            {{ savingStatus ? 'Saving...' : 'Update Status' }}
                        </button>
                    </div>
                </div>

                <div class="card shadow-sm border-0" *ngIf="parseContext(ticket.contextSnapshotJson) as context">
                    <div class="card-body">
                        <h6 class="fw-bold">Context Snapshot</h6>
                        <pre class="small mb-0 support-context-json">{{ context | json }}</pre>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </main>
</div>